import { Actions, Badge, formatDate } from "@";
import type { Theme } from "../types";
import type { ColumnDef } from "@tanstack/react-table";
import TogglePublishStatus from "@/shared/components/dataTable/TogglePublish";
import { useCanShow } from "@/shared/hooks";

interface TableActionsProps {
  row: Theme;
  deleteHandler: (id: number) => Promise<void>;
  TogglePublished: (id: number, value: boolean) => Promise<void>;
}

export const TableActions = ({
  row,
  deleteHandler,
  TogglePublished,
}: TableActionsProps) => {
  return (
    <Actions
      notEdit={!useCanShow("editThemes")}
      notDelete={!useCanShow("editThemes")}
      row={row}
      url="website/themes"
      delete={deleteHandler}
    >
      {useCanShow("publishThemes") && (
        <TogglePublishStatus row={row} click={TogglePublished} />
      )}
    </Actions>
  );
};

export const tableColumns: ColumnDef<Theme>[] = [
  {
    id: "id",
    header: "المعرف",
    size: 80,
    accessorFn: ({ id }) => id,
  },
  {
    id: "title",
    header: "العنوان",
    size: 280,
    accessorFn: ({ title }) =>
      title?.length > 80 ? title.slice(0, 80) + "..." : title,
  },
  {
    id: "createdAt",
    header: "تاريخ الإنشاء",
    size: 160,
    cell: ({ row }) =>
      row.original.createdAt ? formatDate(row.original.createdAt) : "-",
  },
  {
    id: "status",
    header: "الحالة",
    size: 120,
    cell: ({ row }) => (
      <Badge
        title={row.original.isPublished ? "تم النشر" : "مسودة"}
        color={row.original.isPublished ? "green" : "red"}
      />
    ),
  },
];
